<template>
	<div class="stats__filter">
		<main-filter>
			<div class="filters__item">
				<ProductCategories v-model="formData.productGroups" ref="productGroups"/>
			</div>
			<div class="filters__item filters__item--2">
				<InputSelect label="Ответственный МОЗ">
					<template #select>
						<Multiselect
							v-model="formData.manager"
							:options="managersList"
							:label="'name'"
							:value-prop="'id'"
							:can-clear="false"
							:can-deselect="false"
							:no-results-text="'Не найдено'"
							:no-options-text="'Нет данных'"
							searchable
						/>
					</template>
				</InputSelect>
			</div>
			<div class="filters__item filters__item--2">
				<InputDate  v-model="formData.auctionStart" label="Начало торгов" />
			</div>
			<div class="filters__item filters__item--2">
				<div class="filters__btns">
					<button type="submint" class="btn btn--color" @click="handleApplyFilters">Применить</button>
					<button class="btn btn--trans" @click="handleClearFilters">Сбросить фильтр</button>
				</div>
			</div>
		</main-filter>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MainFilter from "@/components/blocks/MainFilter.vue";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import ProductCategories from "@/components/blocks/ProductCategories.vue";
import InputDate from "@/components/base/utils/formElements/InputDate.vue";

export default {
	name: "StatsFilter",
	components: {InputDate, ProductCategories, InputSelect, MainFilter, Multiselect},
	data() {
		return {
			formData: {
				categoryAdmin: '',
				categoryManager: '',
				manager: '',
				auctionStart: [''],
				auctionEnd: [''],
				productGroups: [],
			},

		}
	},
	created() {
		this.requestSchedulesFilters();
	},
	computed: {
		managersList() {
			if (!this.getSchedulesFilters?.managers.length) return [];
			return this.getSchedulesFilters.managers.map(manager => {
				return {
					id: manager.id,
					name: `${manager.name} ${manager.lastName}`,
				}
			})
		},
		categoryAdminsList() {
			if (!this.getSchedulesFilters?.categoryAdmins.length) return [];
			return this.getSchedulesFilters.categoryAdmins.map(manager => {
				return {
					id: manager.id,
					name: `${manager.name} ${manager.lastName}`,
				}
			})
		},
		categoryManagersList() {
			if (!this.getSchedulesFilters?.categoryManagers.length) return [];
			return this.getSchedulesFilters.categoryManagers.map(manager => {
				return {
					id: manager.id,
					name: `${manager.name} ${manager.lastName}`,
				}
			})
		},
		...mapGetters({
			isLoading: 'isLoading',
			getSchedulesFilters: 'schedules/getSchedulesFilters',
		})
	},
	methods: {
		handleApplyFilters() {
			const filter = {
				auctionStart: this.formData.auctionStart[0] ? new Date(this.formData.auctionStart[0]).toLocaleDateString('ru-RU') : null,
				auctionEnd:  this.formData.auctionEnd[0] ? new Date(this.formData.auctionEnd[0]).toLocaleDateString('ru-RU') : null,
				manager: this.formData.manager,
				categoryAdmin: this.formData.categoryAdmin,
				categoryManager: this.formData.categoryManager,
				productGroups: this.formData.productGroups.length ? this.formData.productGroups : null,
			}
			this.updateFilter(filter)
		},

		async handleClearFilters() {
			this.formData.auctionStart = ['']
			this.formData.auctionEnd = ['']
			this.formData.name = ''
			this.formData.manager = ''
			this.formData.categoryAdmin = ''
			this.formData.categoryManager = ''
			await this.$refs.productGroups.clearAll()
			await this.updateFilter({})
		},

		...mapActions({
			updateFilter: 'schedules/updateFilter',
			requestSchedulesFilters: 'schedules/requestSchedulesFilters',
		})
	},
}
</script>
